import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpEvent,
  HttpRequest,
  HttpHandler
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { AuthService } from '../service/auth.service';
import { User } from '../models/user';
import { Router } from '@angular/router';

@Injectable()
export class RequestInterceptor implements HttpInterceptor {

  user: User;
  
  constructor(private authService: AuthService, private router: Router) {
    this.user = this.authService.currentUserValue;
  }

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    // Skip intercepting authenticate requests
    if (httpRequest.url.includes('authenticate')) {
      return next.handle(httpRequest);
    }

    // Retrieve route via router snapshot
    let currentUrl = this.router.routerState.snapshot.url;

    // Fallback to window.location if router snapshot is empty
    if (!currentUrl) {
      currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    }

    // Capture API endpoint
    const apiEndpoint = httpRequest.urlWithParams;

    console.log('Current URL in interceptor:', currentUrl);

    const userPosition = this.authService.getUserPosition();
    const currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');

    // Build the request body with existing data
    let body = httpRequest.body || {};
    
    // Add standard user data
    const updatedBody = {
      ...body,
      filiale_id: currentUser.filiale_id,
      user_id: currentUser.id,
      page_route: currentUrl,
      request_url: apiEndpoint,
    };

    // Only add location data if available
    if (userPosition?.latitude !== undefined && userPosition?.longitude !== undefined) {
      updatedBody.latitude = userPosition.latitude;
      updatedBody.longitude = userPosition.longitude;
    }
    // Clone the request with updated body
    const modifiedRequest = httpRequest.clone({ body: updatedBody });

    return next.handle(modifiedRequest);
  }
}